import { render, staticRenderFns } from "./UIBranding.vue?vue&type=template&id=15d71f5a&scoped=true"
import script from "./UIBranding.vue?vue&type=script&lang=js"
export * from "./UIBranding.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./UIBranding.vue?vue&type=style&index=0&id=15d71f5a&prod&scoped=true&lang=css")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "15d71f5a",
  null
  ,true
)

export default component.exports